import { Routes } from '@angular/router';
import { authGuard } from './auth/auth.guard';
import { roleGuard } from './auth/role.guard';
import { guestGuard } from './auth/guest.guard';

export const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    {
        path: 'login',
        canActivate: [guestGuard],
        loadComponent: () => import('./auth/login/login.component').then(m => m.LoginComponent)
    },
    {
        path: 'home',
        canActivate: [authGuard],
        loadChildren: () => import('./home/home.routes').then(m => m.homeRoutes)
    },
    {
        path: 'admin',
        canActivate: [authGuard, roleGuard],
        data: { roles: ['owner', 'accountant'] },
        loadChildren: () => import('./admin/admin.routes').then(m => m.adminRoutes)
    },
    { path: '**', redirectTo: 'login' }
];
